import { cleanUpTeamsSkillNudgeResource as aggCleanUpTeamsSkillNudgeResource } from '@townsquare/agg-teams-directory-view/resources/clean-up-teams-skill-nudge';
import { teamDirectoryResource as aggTeamDirectoryResource } from '@townsquare/agg-teams-directory-view/resources/team-directory';
import { teamDirectoryTableResource as aggTeamDirectoryTableResource } from '@townsquare/agg-teams-directory-view/resources/team-directory-table';
import Loadable from '@townsquare/loadable';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import type { RouteContext } from '@townsquare/router/routing-types';
import { teamsDirectoryRoute } from '@townsquare/routes/teams-directory-view';
import { tqlExplainerTeamAggResource } from '@townsquare/tql/agg/resource/team-explainer';
import { tqlExplainerResource } from '@townsquare/tql/resource';

import { cleanUpTeamsSkillNudgeResource } from './resources/clean-up-teams-skill-nudge';
import { teamDirectoryResource } from './resources/team-directory';
import { teamDirectoryTableResource } from './resources/team-directory-table';

const TeamsDirectoryLoadable = Loadable<RouteContext, any>({
	loader: () => import(/* webpackChunkName: "teamsDirectory-view" */ './components/TeamDirectory'),
	loading: () => null,
});

const AggTeamsDirectoryLoadable = Loadable<RouteContext, any>({
	loader: () =>
		import(
			/* webpackChunkName: "agg-teams-directory-view" */ '@townsquare/agg-teams-directory-view/AggTeamDirectory'
		),
	loading: () => null,
});

teamsDirectoryRoute.component = TeamsDirectoryLoadable;
teamsDirectoryRoute.resources = [
	teamDirectoryResource,
	tqlExplainerResource,
	teamDirectoryTableResource,
	cleanUpTeamsSkillNudgeResource,
];
teamsDirectoryRoute.featureGating = {
	gates: ['enable-teams-tql-migration-to-agg'],
	behavior: {
		type: 'override',
		override: {
			component: AggTeamsDirectoryLoadable,
			relayEnvironment: 'agg',
			resources: [
				aggTeamDirectoryResource,
				aggTeamDirectoryTableResource,
				tqlExplainerTeamAggResource,
				aggCleanUpTeamsSkillNudgeResource,
			],
		},
	},
};
export const teamsDirectoryRouterRoute: GlobalHomePageRoute = teamsDirectoryRoute;
